export const NAV = {
  INTERVENTIONS: 'interventions',
  INTERVENTION_DETAIL: 'intervention-detail',
  INTERVENTION_LIST: 'list',
  INTERVENTION_SPARE_PARTS: 'spare-parts',
  CREATE_QUOTATION: 'create-quotation',
  QUOTATION_DETAIL: 'quotation-detail',
  FINISH_INTERVENTION: 'finish-intervention',
  ADD_IMAGE: 'add-image',
  CUSTOMER_ABSENT: 'customer-absent',
};

export enum INTERVENTION_SPARE_PARTS_CREATE_TYPE {
  SPARE_PARTS = 'spare-parts',
  QUOTE = 'quote',
}

export const ROUTES = {
  INTERVENTION_DETAIL: `/${NAV.INTERVENTION_DETAIL}/:interventionId`,
  INTERVENTION_SPARE_PARTS: `/${NAV.INTERVENTION_DETAIL}/:interventionId/${NAV.INTERVENTION_SPARE_PARTS}/:interventionSparePartsCreateType?`,
  CREATE_QUOTATION: `/${NAV.INTERVENTION_DETAIL}/:interventionId/${NAV.CREATE_QUOTATION}`,
  QUOTATION_DETAIL: `/${NAV.INTERVENTION_DETAIL}/:interventionId/${NAV.QUOTATION_DETAIL}/:quotationId`,
  INTERVENTIONS_LIST: `/${NAV.INTERVENTIONS}/${NAV.INTERVENTION_LIST}`,
  FINISH_INTERVENTION: `/${NAV.INTERVENTION_DETAIL}/:interventionId/${NAV.FINISH_INTERVENTION}`,
  ADD_IMAGE: `/${NAV.INTERVENTION_DETAIL}/:interventionId/${NAV.ADD_IMAGE}`,
  ADD_DOCUMENT_TYPE_IMAGE: `/${NAV.INTERVENTION_DETAIL}/:interventionId/${NAV.ADD_IMAGE}/:documentType/:originAction?`,
  CUSTOMER_ABSENT: `/${NAV.INTERVENTION_DETAIL}/:interventionId/${NAV.CUSTOMER_ABSENT}`,
};
